import React, { useState } from 'react';
import EditDialog from './EditDialog';
import BusinessDatesAndTimes from '../../DateAndTimePage/BusinessDatesAndTimes';

export default function EditSchedulesModal({
    open,
    onClose,
    headline,
}: {
    open: boolean;
    onClose: () => void;
    headline: string;
}) {
    const [isValid, setIsValid] = useState(false);

    function closeIfValid() {
        if (isValid) {
            onClose();
        }
    }

    return (
        <EditDialog title={`Edit ${headline} Schedule`} open={open} onClose={closeIfValid} isValid={isValid}>
            <BusinessDatesAndTimes setIsValid={setIsValid} />
        </EditDialog>
    );
}
